@if (offerTheStep) {
  <div class="thp-form-container" id="video-interview-landing-page-container">
    <div class="thp-message">
      <h1 id="video-interview-landing-page-header" class="thp-header">{{ "talent-happy-path.video-interview.landing-page.header" | translate }}</h1>
      <p id="video-interview-landing-page-sub-header" class="thp-sub-header">{{ "talent-happy-path.video-interview.landing-page.body" | translate }}</p>
    </div>
  </div>
  <div class="button-container">
    <button mat-flat-button id="video-interview-landing-page-start-button" class="custom-button" (click)="clickStartVideoInterview()">
      {{ "talent-happy-path.video-interview.landing-page.start-button" | translate }}
    </button>
    <button mat-button id="video-interview-landing-page-do-later" class="later-button" (click)="clickIllDoThisLater()">
      {{ "talent-happy-path.buttons.do-later" | translate }}
    </button>
  </div>
} @else {
  <div class="thp-form-container" id="video-interview-landing-page-container">
    <div class="thp-message">
      <div class="spinner-container">
        <mat-spinner [diameter]="40"></mat-spinner>
      </div>
    </div>
  </div>
}
